import { render } from "./UiIconDocumentDownload.vue?vue&type=template&id=1bbcbfdc"
const script = {}

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__